/**
 * Endpoints que emiten los tokens. Quedan fuera del reintento por 403: si ellos
 * mismos rechazan, no hay credencial que renovar y el proceso termina en la
 * pantalla de rechazo.
 */
export const AUTH_ISSUER_ENDPOINT_PATTERN =
	/\/(initial_steps_auths|evaluation_steps_auths)\b/;

/**
 * Mensaje que ve el socio en la pantalla de rechazo cuando no se pudieron
 * validar los permisos. Deliberadamente no menciona tokens ni sesiones.
 */
export const AUTH_REJECTED_MESSAGE =
	'No pudimos validar los permisos para completar esta acción. Vuelve a iniciar tu solicitud o comunícate con nosotros para ayudarte.';

/**
 * Folio que se pinta en la pantalla de rechazo. Es el marcador interno del
 * caso: si un socio reporta este folio, el rechazo viene de un 403 que no se
 * pudo recuperar y no de una evaluación de crédito.
 */
export const AUTH_REJECTED_CODE = 'F403-AUTH';

/**
 * tipoMedio con el que se emite el token de evaluación. Es el mismo que usa el
 * OTP de crédito al validarse por primera vez.
 */
export const EVALUATION_TOKEN_MEDIA_TYPE = 4;
